export type ImportantKpiEntry = {
  questionId: number
  importantOptions?: string[]
}

export enum SelectionStatus {
  None = 'None',
  Some = 'Some',
  All = 'All',
}
